import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { useCreateDeliveryZoneMutation, TotadminPermission } from 'data/__generated__';

import { TotemInput } from 'components/TotemInput';
import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';

const DEFAULT_COLOR = '#3B82F6';

export function DeliveryZonePopup({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (arg: boolean) => void }) {
    const navigate = useNavigate();
    const [name, setName] = useState<string>('');
    const [color, setColor] = useState<string>(DEFAULT_COLOR);

    const [createDeliveryZone, { loading }] = useCreateDeliveryZoneMutation();

    const handleClose = () => {
        setIsOpen(false);
        setName('');
        setColor(DEFAULT_COLOR);
    };

    const handleSubmit = async () => {
        try {
            const result = await createDeliveryZone({ variables: { input: { name, color } } });
            const newZoneId = result.data?.createDeliveryZone._id;
            if (newZoneId) {
                toast.success('Zone créée');
                setIsOpen(false);
                setName('');
                setColor(DEFAULT_COLOR);
                navigate(`/delivery-zone/${newZoneId}`);
            } else {
                toast.error('Une erreur est survenue lors de la création de la zone');
            }
        } catch (error) {
            toast.error('Une erreur est survenue lors de la création de la zone');
        }
    };

    return (
        <TotemPopup title="Créer une zone" isOpen={isOpen} setIsOpen={handleClose} contentOverflow="visible">
            <Fields>
                <TotemInput label="Nom de la zone" onChange={setName} placeholder="Nom" value={name} autoFocus />
                <ColorField>
                    <ColorLabel>Couleur</ColorLabel>
                    <input type="color" value={color} onChange={(e) => setColor(e.target.value)} />
                </ColorField>
                <TotemPrimaryLoadingButton
                    onClick={handleSubmit}
                    disabled={!name || !color}
                    loading={loading}
                    useIcon={false}
                    label="Créer et configurer"
                    requiredPermissions={[TotadminPermission.DeliveryZonesManage]}
                />
            </Fields>
        </TotemPopup>
    );
}

const Fields = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 15px;

    > :not(:first-child) {
        margin-top: 15px;
    }
`;

const ColorField = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const ColorLabel = styled.span`
    color: ${({ theme }) => theme.textColor};
    font-weight: 600;
`;
